module.exports = __webpack_public_path__ + "img/slogan-preview2.60ad2bad.jpg";